module.exports = __webpack_public_path__ + "img/Img38_197288_CeEt-8-1A7-520.202f0035.jpg";